import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Cocogroup';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'

/**
 * Landing por rol. PERSONAL_LOCAL (funcionario) arranca en /canjear (el
 * scanner QR es lo único que hace en su día a día). ADMIN y SOCIO_USER
 * arrancan en /cupones, que es el listado + botón "Generar cupón". Para
 * un user sin tipo definido (estado transitorio post-login mientras se
 * carga /auth/me) caemos a /cupones — funciona para 2 de 3 roles y el
 * tercero se redirige solo cuando se carga el me().
 */
export const ENTRY_BY_TIPO = {
  ADMIN: `${APP_PREFIX_PATH}/cupones`,
  SOCIO_USER: `${APP_PREFIX_PATH}/cupones`,
  PERSONAL_LOCAL: `${APP_PREFIX_PATH}/canjear`,
};
export const DEFAULT_AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/cupones`;
export const getAuthenticatedEntry = (me) =>
  ENTRY_BY_TIPO[me?.tipoUsuario] ?? DEFAULT_AUTHENTICATED_ENTRY;

// Compat con código viejo que importe AUTHENTICATED_ENTRY. Apunta al
// fallback; las rutas dinámicas usan getAuthenticatedEntry(me).
export const AUTHENTICATED_ENTRY = DEFAULT_AUTHENTICATED_ENTRY;

export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#6F4E37',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
